export default "__VITE_ASSET__Bn92ffng__"